// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LQ0n","field":"styles_field__2gLn-","fieldCol":"styles_fieldCol__FamCd","diffCol":"styles_diffCol__3VUhc","diff":"styles_diff__1K8yd"};